export default "__VITE_ASSET__CqrR2_uY__"